import { useContext } from 'react';
import { MeContext } from '../context/MeContext';

const READ_ONLY_STATUSES = ['trial_expired', 'locked'];

export const useIsReadOnly = (): boolean => {
  const { state } = useContext(MeContext);
  return Boolean(
    state.readOnlyDashboardEnabled &&
    READ_ONLY_STATUSES.includes(state.organisationStatus)
  );
};
